import React, { useEffect, useRef } from 'react';

const ITEM_H = 36;
const VISIBLE = 3;
const PAD_ROWS = 1;

const columnStyle = {
  flex: 1,
  minWidth: 0,
  textAlign: 'center',
};

const wheelStyle = {
  height: ITEM_H * VISIBLE,
  overflowY: 'auto',
  scrollSnapType: 'y mandatory',
  WebkitOverflowScrolling: 'touch',
  borderRadius: '8px',
  border: '1px solid rgba(201,168,76,0.2)',
  background: 'rgba(0,0,0,0.35)',
  scrollbarWidth: 'thin',
};

const labelStyle = {
  color: '#8896a8',
  fontSize: '10px',
  marginBottom: '4px',
  textTransform: 'uppercase',
  letterSpacing: '0.06em',
};

function pad2(n) {
  return String(n).padStart(2, '0');
}

function ScrollColumn({ label, value, max, onChange }) {
  const wheelRef = useRef(null);
  const skipScrollRef = useRef(false);

  useEffect(() => {
    const el = wheelRef.current;
    if (!el) return;
    skipScrollRef.current = true;
    el.scrollTop = (PAD_ROWS + value) * ITEM_H;
    const t = setTimeout(() => { skipScrollRef.current = false; }, 80);
    return () => clearTimeout(t);
  }, [value]);

  const handleScroll = () => {
    if (skipScrollRef.current) return;
    const el = wheelRef.current;
    if (!el) return;
    const index = Math.round(el.scrollTop / ITEM_H) - PAD_ROWS;
    const clamped = Math.min(max, Math.max(0, index));
    if (clamped !== value) onChange(clamped);
  };

  const items = [];
  for (let i = 0; i < PAD_ROWS; i += 1) {
    items.push(<div key={`pad-top-${i}`} style={{ height: ITEM_H, scrollSnapAlign: 'center' }} />);
  }
  for (let i = 0; i <= max; i += 1) {
    const selected = i === value;
    items.push(
      <div
        key={i}
        style={{
          height: ITEM_H,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          scrollSnapAlign: 'center',
          fontSize: selected ? '18px' : '14px',
          fontWeight: selected ? 800 : 500,
          color: selected ? '#E8D5A3' : 'rgba(232,224,208,0.45)',
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {pad2(i)}
      </div>,
    );
  }
  for (let i = 0; i < PAD_ROWS; i += 1) {
    items.push(<div key={`pad-bot-${i}`} style={{ height: ITEM_H, scrollSnapAlign: 'center' }} />);
  }

  return (
    <div style={columnStyle}>
      <div style={labelStyle}>{label}</div>
      <div ref={wheelRef} style={wheelStyle} onScroll={handleScroll}>
        {items}
      </div>
    </div>
  );
}

export default function TimeHmsScrollPicker({ hours, minutes, seconds, onChange, maxHours = 99 }) {
  return (
    <div>
      <div
        style={{
          display: 'flex',
          gap: '8px',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        <ScrollColumn
          label="Hr"
          value={hours}
          max={maxHours}
          onChange={(h) => onChange({ hours: h, minutes, seconds })}
        />
        <span style={{ color: '#c9a84c', fontWeight: 700, fontSize: '18px', paddingTop: '18px' }}>:</span>
        <ScrollColumn
          label="Min"
          value={minutes}
          max={59}
          onChange={(m) => onChange({ hours, minutes: m, seconds })}
        />
        <span style={{ color: '#c9a84c', fontWeight: 700, fontSize: '18px', paddingTop: '18px' }}>:</span>
        <ScrollColumn
          label="Sec"
          value={seconds}
          max={59}
          onChange={(s) => onChange({ hours, minutes, seconds: s })}
        />
      </div>
      <p style={{ textAlign: 'center', color: '#c9a84c', fontSize: '20px', fontWeight: 800, margin: '10px 0 0', fontVariantNumeric: 'tabular-nums' }}>
        {pad2(hours)}:{pad2(minutes)}:{pad2(seconds)}
      </p>
    </div>
  );
}
